import { setupState } from './core-utils'
export default setupState()
